'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rxApi = exports.api = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _fetch2 = require('./rx/fetch');

var _utils = require('./utils');

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Methods = Object.freeze({
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
  OPTIONS: 'OPTIONS',
  HEAD: 'HEAD'
});

var Mode = Object.freeze({
  SAME: "same-origin",
  CORS: "cors",
  CORS_PREFLIGHT: "cors-with-forced-preflight",
  NO_CORS: "no-cors"
});

var defaults = Object.freeze({
  method: Methods.GET,
  mode: Mode.CORS,
  data: undefined,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  dump: function dump(data) {
    return JSON.stringify(data);
  },
  raw: false,
  auth: true,
  clientId: false,
  params: undefined,
  file: false
});

function getHeaders(options) {
  var headers = options.auth ? _extends({}, defaults.headers, (0, _utils.getAuthorizationHeader)(), options.headers) : _extends({}, defaults.headers, options.headers);

  if (options.file) {
    delete headers['Content-Type'];
  }

  return headers;
}

var createClient = function createClient(_fetch) {
  return function (args) {
    var options = _extends({}, defaults, args);

    var params = options.clientId ? _extends({}, options.params, { clientId: _constants2.default.CLIENT_ID }) : options.params;

    var headers = getHeaders(options);

    var url = params ? '' + options.baseUrl + options.url + '?' + (0, _utils.encodeQueryData)(params) : '' + options.baseUrl + options.url;

    return _fetch(url, {
      method: options.method,
      headers: headers,
      responseType: options.responseType || 'json',
      body: options.raw || options.file ? options.data : options.dump(options.data)
    });
  };
};

var apiFactory = function apiFactory(client) {
  return function (baseUrl, clientDefaults) {
    var _ref;

    return _ref = {
      get: function get(url, params, args) {
        return client(_extends({}, { baseUrl: baseUrl, url: url, method: Methods.GET, params: params }, _extends({}, clientDefaults, args)));
      },
      put: function put(url, data, args) {
        return client(_extends({}, { baseUrl: baseUrl, url: url, method: Methods.PUT, data: data }, _extends({}, clientDefaults, args)));
      },
      post: function post(url, data, args) {
        return client(_extends({}, { baseUrl: baseUrl, url: url, method: Methods.POST, data: data }, _extends({}, clientDefaults, args)));
      },
      patch: function patch(url, data, args) {
        return client(_extends({}, { baseUrl: baseUrl, url: url, method: Methods.PATCH, data: data }, _extends({}, clientDefaults, args)));
      }
    }, _defineProperty(_ref, 'delete', function _delete(url, data, args) {
      return client(_extends({}, { baseUrl: baseUrl, url: url, method: Methods.DELETE, data: data }, _extends({}, clientDefaults, args)));
    }), _defineProperty(_ref, 'options', function options(url, args) {
      return client(_extends({}, { baseUrl: baseUrl, url: url, method: Methods.OPTIONS }, _extends({}, clientDefaults, args)));
    }), _defineProperty(_ref, 'head', function head(url, params, args) {
      return client(_extends({}, { baseUrl: baseUrl, url: url, method: Methods.HEAD, params: params }, _extends({}, clientDefaults, args)));
    }), _ref;
  };
};

var api = exports.api = apiFactory(createClient(fetch));
var rxApi = exports.rxApi = apiFactory(createClient(_fetch2.rxFetch));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@drifthq/dapper/lib/client.js
// module id = 1899
// module chunks = 0